<button
  type="button"
  class="search-bar-button inline-flex max-w-full items-center justify-center gap-1 rounded-lg! px-2 py-1 cursor-pointer focus-visible:outline-2 focus-visible:outline-primary-purple"
  [class.bg-neutrals-white!]="!isActive()"
  [class.bg-primary-purple-light-2!]="isActive()"
  [class.border-primary-purple-light!]="isActive()"
  [class.filtersApplied]="isActive()"
  [attr.aria-label]="showLabel() ? null : literalService.get(labelKey(), true)"
  [tooltip]="literalService.get(labelKey(), true)"
  (click)="sort.emit()"
>
  <img [src]="icon()" alt="" aria-hidden="true" class="h-5 w-5 shrink-0 filter-primary-purple-light" />
  @if (showLabel()) {
    <span class="truncate text-base font-semibold">{{ literalService.get(labelKey(), true) }}</span>
  }
  @if (isActive()) {
    <img
      [src]="images.sortArrowDown"
      alt=""
      aria-hidden="true"
      class="h-4 w-4 shrink-0 filter-primary-purple-light"
      [class.rotate-180]="isAscending()"
    />
  }
</button>
<ng-content />

